export default "__VITE_ASSET__CmWPCavw__"